// get_marketplace_categories
export const GET_MARKETPLACE_CATEGORIES = 'get_marketplace_categories';
export const GET_MARKETPLACE_CATEGORIES_SUCCESSFUL =
  'get_marketplace_categories_successfull';
export const GET_MARKETPLACE_CATEGORIES_FAILED =
  'get_marketplace_categories_failed';

// create_marketplace_category
export const CREATE_MARKETPLACE_CATEGORY = 'create_marketplace_category';
export const CREATE_MARKETPLACE_CATEGORY_SUCCESSFUL =
  'create_marketplace_category_successfull';
export const CREATE_MARKETPLACE_CATEGORY_FAILED =
  'create_marketplace_category_failed';

// update_marketplace_category
export const UPDATE_MARKETPLACE_CATEGORY = 'update_marketplace_category';
export const UPDATE_MARKETPLACE_CATEGORY_SUCCESSFUL =
  'update_marketplace_category_successfull';
export const UPDATE_MARKETPLACE_CATEGORY_FAILED =
  'update_marketplace_category_failed';

// delete_marketplace_category
export const DELETE_MARKETPLACE_CATEGORY = 'delete_marketplace_category';
export const DELETE_MARKETPLACE_CATEGORY_SUCCESSFUL =
  'delete_marketplace_category_successfull';
export const DELETE_MARKETPLACE_CATEGORY_FAILED =
  'delete_marketplace_category_failed';
